const authActions = {
  CANDIDATE_LOGIN:'CANDIDATE_LOGIN',
};

export default authActions;
